import z from "zod/v4";
import {
  deliveryPerformanceDistributionBucket,
  deliveryPerformanceFilterInput,
  deliveryPerformanceMetrics,
  deliveryPerformanceTimeSeriesPoint,
} from "./delivery-analytics-v2-types";

const deliveryAnalyticsV2ChartsData = z.object({
  kpis: z.object({
    current: deliveryPerformanceMetrics,
    comparison: deliveryPerformanceMetrics.nullable(),
  }),
  timeSeries: z.array(deliveryPerformanceTimeSeriesPoint),
  timeSeriesComparison: z.array(deliveryPerformanceTimeSeriesPoint).nullable(),
  distributions: z.object({
    orderToDelivery: z.array(deliveryPerformanceDistributionBucket),
    processing: z.array(deliveryPerformanceDistributionBucket),
    pickup: z.array(deliveryPerformanceDistributionBucket),
    transit: z.array(deliveryPerformanceDistributionBucket),
  }),
});

export type DeliveryAnalyticsV2ChartsData = z.infer<
  typeof deliveryAnalyticsV2ChartsData
>;

export const getDeliveryAnalyticsV2Charts = {
  name: "getDeliveryAnalyticsV2Charts",
  input: deliveryPerformanceFilterInput.extend({ compareEnabled: z.boolean() }),
  output: deliveryAnalyticsV2ChartsData,
};
